// Personas section (US-107) — section header with AI assist + the persona
// sub-editor. JSX lifted verbatim from BusinessEditor.

import { useT } from '@barel/i18n';
import { BAiButton, Card } from '@barel/ui';

import { PersonaEditor } from '../PersonaEditor';
import type { BusinessDraft } from '../lib/defaults';
import { SectionHeader } from './SectionHeader';
import type { RunAi, SetField } from './types';

export interface PersonasSectionProps {
  personas: BusinessDraft['personas'];
  onChange: SetField;
  runAi: RunAi;
  aiBusyField: string | null;
}

export function PersonasSection({ personas, onChange, runAi, aiBusyField }: PersonasSectionProps) {
  const t = useT('businesses');

  return (
    <Card padding="lg" radius="2xl" data-testid="business-section-personas">
      <SectionHeader
        title={t('sections.personas')}
        subtitle={t('personas.subtitle')}
        action={
          <BAiButton
            onClick={() => void runAi('personas')}
            busy={aiBusyField === 'personas'}
            label={t('personas.ai')}
            busyLabel={t('personas.aiBusy')}
            data-testid="business-personas-ai"
          />
        }
      />
      <PersonaEditor values={personas} onChange={(next) => onChange('personas', next)} />
    </Card>
  );
}
